import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Recommend from './recommend';
import Subject from './subject';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { searchPath, recommend, subject },
        } = this.props;

        return (
            <div className={styles.rightContent}>
                <NoSSR>
                    <Chip
                        id={`${searchPath === '3-35193-' ? 25023 : 25024}`}
                        type="static"
                        title="栏目推荐"
                        groupName="侧栏"
                        translate="jsonParse"
                        content={recommend}>
                        <Recommend />
                    </Chip>
                </NoSSR>
                <Chip
                    id="55048"
                    type="recommend"
                    title="专题策划"
                    groupName="侧栏"
                    translate="handleSubjectData"
                    content={subject}>
                    <Subject />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(RightContent);
